import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Premium home service card — icon, title, description, CTA.
 * Inspired by Stripe / Linear / Notion: white, centered, no illustrations.
 */
export function ServiceCard({
  title,
  description,
  cta,
  icon: Icon,
  onSelect,
  testId,
  className = "",
}) {
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={onSelect}
      aria-label={title}
      className={cn(
        "group flex min-h-[320px] w-full flex-col items-center justify-center rounded-[24px] bg-white px-5 py-8 text-center sm:min-h-0 sm:h-[440px] sm:p-10 lg:h-[460px]",
        "border border-[#E5E7EB]",
        // Stronger depth on phone; lighter on desktop
        "shadow-[0_16px_42px_rgba(24,24,27,0.16),0_6px_16px_rgba(24,24,27,0.08)]",
        "sm:shadow-[0_10px_30px_rgba(0,0,0,0.05)]",
        "transition-[transform,box-shadow] duration-300 ease-out",
        "hover:-translate-y-1.5 hover:shadow-[0_24px_52px_rgba(24,24,27,0.20),0_10px_22px_rgba(24,24,27,0.10)]",
        "sm:hover:shadow-[0_20px_45px_rgba(0,0,0,0.10)]",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-matpro-green focus-visible:ring-offset-2",
        "active:scale-[0.99]",
        className,
      )}
    >
      <div className="flex h-[70px] w-[70px] shrink-0 items-center justify-center text-matpro-green transition-transform duration-300 ease-out group-hover:scale-105">
        <Icon className="h-[70px] w-[70px]" strokeWidth={1.35} aria-hidden />
      </div>

      <h2 className="mt-6 font-heading text-[24px] font-extrabold leading-tight tracking-tight text-matpro-anthracite sm:mt-7 sm:text-[32px] lg:text-[36px]">
        {title}
      </h2>

      <p className="mx-auto mt-4 max-w-[320px] text-base leading-relaxed text-[#6B7280] sm:text-lg">
        {description}
      </p>

      <span className="mt-8 inline-flex h-12 items-center justify-center gap-2 rounded-xl bg-matpro-green px-7 text-sm font-bold text-white transition-colors duration-200 group-hover:bg-matpro-green-dark">
        {cta}
        <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" aria-hidden />
      </span>
    </button>
  );
}
